var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.9736C10.0124 14.9736 10.4277 14.5583 10.4277 14.0459C10.4277 13.5335 10.0124 13.1182 9.5 13.1182C8.98763 13.1182 8.57227 13.5335 8.57227 14.0459C8.57227 14.5583 8.98763 14.9736 9.5 14.9736Z",
    fill: "#C9C9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.24962 0 0 4.24891 0 9.5C0 14.7504 4.24891 19 9.5 19C14.7504 19 19 14.7511 19 9.5C19 4.24962 14.7511 0 9.5 0ZM9.5 17.5156C5.06999 17.5156 1.48438 13.9306 1.48438 9.5C1.48438 5.06999 5.0694 1.48438 9.5 1.48438C13.93 1.48438 17.5156 5.0694 17.5156 9.5C17.5156 13.93 13.9306 17.5156 9.5 17.5156Z",
    fill: "#C9C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.76843C7.86303 4.76843 6.53125 6.10022 6.53125 7.73721C6.53125 8.14712 6.86353 8.4794 7.27344 8.4794C7.68335 8.4794 8.01562 8.14712 8.01562 7.73721C8.01562 6.91871 8.68152 6.25282 9.5 6.25282C10.3185 6.25282 10.9844 6.91871 10.9844 7.73721C10.9844 8.5557 10.3185 9.22159 9.5 9.22159C9.09009 9.22159 8.75781 9.55387 8.75781 9.96378V11.8193C8.75781 12.2292 9.09009 12.5615 9.5 12.5615C9.90991 12.5615 10.2422 12.2292 10.2422 11.8193V10.6121C11.5212 10.2817 12.4688 9.11802 12.4688 7.73721C12.4688 6.10022 11.137 4.76843 9.5 4.76843Z",
    fill: "#C9C9C9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.93e0e6e0.svg";
export { ForwardRef as ReactComponent };